import "./SectionHeader.scss";

import React, { FC, useContext, useEffect, useState } from "react";
import NavContext from "../Layout/Nav/NavProvider";

import { HeaderIcon } from "../../components";
import BurgerButton from "../BurgerButton";
import { getCurrentLanguage, getLanguages } from "../../i18n";
import { getSectionConfigByURL } from "../../constants/general";

export interface SectionHeaderProps {
  h1?: string;
  p?: string;
  inView?: boolean;
  color?: string;
  isRelative?: boolean;
  hideInFirstSlide?: boolean;
  navigateTop?: boolean;
  isTop?: boolean;
}
const isBrowser = typeof window !== "undefined";

const SectionHeader: FC<SectionHeaderProps> = ({
  h1,
  inView,
  p,
  isRelative,
  hideInFirstSlide,
  navigateTop,
  isTop,
}) => {
  if (!isBrowser) return null;
  const { activeSlide, setCurrentSlide, toggleMenu, isMobile, footerInView } = useContext(NavContext);
  const [isMobileActive, setIsMobileActive] = useState<boolean>(false);
  const currentLanguage = getCurrentLanguage()
  const languages = getLanguages()
  const currentSection = getSectionConfigByURL(window?.location?.pathname);

  const onChangeLang = (lang: string) => {
    const sectionURLPerLang = currentSection?.urls.find((url) => url.lang === lang);
    window.location.href = `/${lang}/${sectionURLPerLang?.value}`;
  };

  useEffect(() => {
    setIsMobileActive(isMobile());
  }, [isMobile])
  
  return (
    <div
      className={`section-header ${inView ? "section-header--in-view" : ""} ${
        footerInView ? "section-header--hide" : ""
      } ${isRelative ? "is-absolute" : ""} ${!h1 && !p ? "is-only-icon" : ""} ${
        isTop ? "is-top" : ""
      }`}
    >
      <div className="section-header__content">
        <div className="section-header__row">
          <div className={`section-header__button`}>
            <BurgerButton opened={false} clickHandler={toggleMenu} />
          </div>
          <details className="custom-select">
            <summary>
              {currentLanguage.toUpperCase()}
            </summary>
            <ul className="list">
              {languages.map((lang) => (
                <li
                  key={lang}
                  value={lang}
                  onClick={() => onChangeLang(lang)}
                >
                  {lang.toUpperCase()}
                </li>
              ))}
            </ul>
          </details>
          {!isMobileActive && hideInFirstSlide && activeSlide === 0 ? (
            <></>
          ) : (
            <div className="section-header__row-right">
             
              <HeaderIcon
                hasSlideDelay={hideInFirstSlide && activeSlide != 0}
                goToTop={navigateTop}
                onClick={(value) => setCurrentSlide(value)}
              />
            </div>
          )}
        </div>
        {h1 && <h1 className="section-header__h1">{h1}</h1>}
        {p && <p className="section-header__h1">{p}</p>}
      </div>
    </div>
  );
};
export default SectionHeader;
